<template>
  <div class="toasts">
    <div
      v-for="transitionGroup in transitionGroupToasts"
      :key="transitionGroup.position"
    >
      <transition-group
        :name="transitionGroup.name"
        :class="transitionGroup.class"
        :key="transitionGroup.position"
        tag="div"
        class="w-1/4 toast-group"
      >
        <Toast
          class="toast"
          v-for="toast in filteredToasts[transitionGroup.position]"
          v-bind="toast"
          :key="toast.id"
          :type="toast.type"
          :autoHideDuration="toast.dismissible ? toast.dismissIn : null"
          @close="removeToast(toast.id)"
        >
          <Icon
            v-if="toast.icon"
            :name="toast.icon"
            class="fa-lg text-dull-dark"
            slot="icon"
          />
          <p v-if="toast.title" class="text-sm text-secondary-dark">{{ toast.title }}</p>
          <p v-if="toast.content" class="text-sm text-dull-dark">
            {{ toast.content }}
          </p>
        </Toast>
      </transition-group>
    </div>
  </div>
</template>

<script>
/*
Read readme.md
*/

import Toast from './ToastsHelper';
import Icon from '@converdy/atoms/Icon';

const transitionGroupToasts = [
  {
    position: 'left',
    name: 'slide-from-left',
    class: 'left-toasts',
  },
  {
    position: 'right',
    name: 'slide-from-right',
    class: 'right-toasts',
  },
  {
    position: 'top-left',
    name: 'slide-from-left',
    class: 'top-left-toasts',
  },
  {
    position: 'top-center',
    name: 'slide-from-top',
    class: 'top-center-toasts',
  },
  {
    position: 'top-right',
    name: 'slide-from-right',
    class: 'top-right-toasts',
  },
  {
    position: 'bottom-left',
    name: 'slide-from-left',
    class: 'bottom-left-toasts',
  },
  {
    position: 'bottom-center',
    name: 'slide-from-bottom',
    class: 'bottom-center-toasts',
  },
  {
    position: 'bottom-right',
    name: 'slide-from-right',
    class: 'bottom-right-toasts',
  },
];

export default {
  components: {
    Toast,
    Icon,
  },
  data: () => ({
    toasts: [],
    transitionGroupToasts: transitionGroupToasts,
  }),
  mounted() {
    document.addEventListener(
      'converdySuperToast',
      this.addToastFromEventListner,
    );
  },
  beforeDestroy() {
    document.removeEventListener(
      'converdySuperToast',
      this.addToastFromEventListner,
    );
  },

  methods: {
    /* Custom Event listners only support additional data through details... */
    addToastFromEventListner({detail}) {
      this.addToast(detail);
    },

    addToast(options = {}) {
      /* Todo if we decide to include lodash mergeDeep or defaultsDeep in the client bundle than it would be
      cleaner to use that.. */
      this.toasts.push({
        id: options.id || String(new Date().valueOf()),
        type: options.type || 'warning',
        content: options.content || '',
        title: options.title || '',
        dismissible:
          typeof options.dismissible !== 'undefined'
            ? options.dismissible
            : true,
        dismissIn:
          typeof options.dismissIn !== 'undefined' ? options.dismissIn : 2500,
        position: options.position || 'top-right',
        icon: options.icon || null,
      });
    },
    removeToast(id) {
      this.toasts = this.toasts.filter((t) => t.id !== id);
    },
    removeAllToasts() {
      this.toasts = [];
    },
  },
  computed: {
    filteredToasts() {
      const filter = {
        left: [],
        right: [],
        'top-left': [],
        'top-center': [],
        'top-right': [],
        'bottom-left': [],
        'bottom-center': [],
        'bottom-right': [],
      };
      this.toasts.map((toast) => filter[toast.position].push(toast));
      return filter;
    },
  },
};
</script>

<style>
.toasts {
  z-index: 10000;
  --offset: 15px;
}

.toast-group {
  z-index: 10000;
}

.right-toasts {
  position: fixed;
  top: 50%;
  right: var(--offset);
  transform: translateY(-50%);
}

.left-toasts {
  position: fixed;
  top: 50%;
  left: var(--offset);
  transform: translateY(-50%);
}

.top-right-toasts {
  position: fixed;
  top: var(--offset);
  right: var(--offset);
}

.top-left-toasts {
  position: fixed;
  top: var(--offset);
  left: var(--offset);
}

.top-center-toasts {
  position: fixed;
  top: var(--offset);
  left: 50%;
  transform: translateX(-50%);
}

.bottom-left-toasts {
  position: fixed;
  bottom: var(--offset);
  left: var(--offset);
}

.bottom-right-toasts {
  position: fixed;
  bottom: var(--offset);
  right: var(--offset);
}

.bottom-center-toasts {
  position: fixed;
  bottom: var(--offset);
  left: 50%;
  transform: translateX(-50%);
}

.slide-from-right-enter-active,
.slide-from-right-leave-active {
  transition: all 500ms;
}
.slide-from-right-enter,
.slide-from-right-leave-to {
  opacity: 0;
  transform: translateX(50%);
}

.slide-from-left-enter-active,
.slide-from-left-leave-active {
  transition: all 500ms;
}
.slide-from-left-enter,
.slide-from-left-leave-to {
  opacity: 0;
  transform: translateX(-50%);
}

.slide-from-top-enter-active,
.slide-from-top-leave-active {
  transition: all 500ms;
}
.slide-from-top-enter,
.slide-from-top-leave-to {
  opacity: 0;
  transform: translateY(-50%);
}

.slide-from-bottom-enter-active,
.slide-from-bottom-leave-active {
  transition: all 500ms;
}
.slide-from-bottom-enter,
.slide-from-bottom-leave-to {
  opacity: 0;
  transform: translateY(50%);
}
</style>
